import React, { Component } from "react"
import ReactDOM from "react-dom"
import {
  Switch,
  Route,
  HashRouter as Router,
  withRouter
} from "react-router-dom"

//IMPORT REDUX
import { connect } from "react-redux"

//IMPORT REACT COMPONENTS
import ProAccueilComponent from "./Accueil/ProAccueilComponent"
import DevisFacturesComponent from "./DevisFactures/Home"
import MateriauxComponent from "./Materiaux/MateriauxComponent"
import ClientsComponent from "./Clients/ClientsComponent"
import EditionDevisFacturesComponent from "./DevisFactures/EditionDevisFactures/EditionDevisFacturesComponent"
import ParametresRouter from "./Parametres/ParametresRouter"
import LandingPageComponent from "./AcceuilLandingPage/LandingPageComponent"
import PageLandingComponent from "./LandingPage/PageLandingComponent"

const mapStateToProps = state => {
  return { token: state }
}

class ConnectedProRouter extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <main>
        <Switch>
          <Route path="/mtpro/parametre/footer" component={ParametresRouter} />
          <Route
            path="/mtpro/parametre/entreprise"
            component={ParametresRouter}
          />
          <Route
            path="/mtpro/parametre/devisfacture"
            component={ParametresRouter}
          />
          <Route path="/mtpro/parametre" component={ParametresRouter} />
          <Route
            path="/mtpro/devis/editionDevis"
            component={EditionDevisFacturesComponent}
          />
          {/* <Route path="/mtpro/boby" component={PageLandingComponent} /> */}
          <Route path="/mtpro/lobby" component={LandingPageComponent} />
          <Route path="/mtpro/devis" component={DevisFacturesComponent} />
          {/* TODO Ajouter routes vers les autres interfaces */}
          <Route path="/mtpro/Materiaux" component={MateriauxComponent} />
          <Route path="/mtpro/clients" component={ClientsComponent} />
          <Route path="/mtpro/" component={ProAccueilComponent} />
        </Switch>
      </main>
    )
  }
}

const ProRouter = withRouter(connect(mapStateToProps)(ConnectedProRouter))
export default ProRouter



// WEBPACK FOOTER //
// ./src/components/Pro/ProRouter.js